
import axiosInstance from "./axiosInstance";

export interface Certificate {
    certificates: any;
    uploadedBy: string;
    assignedAt?: string;
    certificateId: string;
    calibrationId: any;
    assetId: string;
    assetName: string,
    vendorName: string;
    Uploaddate: string;
    status: string;
    actions: string;
    uploadedAt: string;
    createdAt: string;
    organizationName: string;
    name: string;
    fileName: string,
    contentType: string,
    type: string;
    orgId: string;
    locationId: string;
    vendorId: string;
    locationName: string;
    certificateName: string;
    calibrationName: string;
    contactNumber: string;
    FileUrl: string;
    departmentId: string;
    calibrationDate: string;
    calibrationFrequency: string;
    calibrationDueDate: string;
    noOfCertificates: number;
}


export interface HeaderContext {
    orgInfo: orgInfo;
    locationInfo: locationInfo;
    assetInfo: assetInfo;
    vendorInfo: vendorInfo;
    departmentInfo: departmentinfo;
}

export interface orgInfo {
    id: string,
    name: string,
    contact: string,
    gsTin: string
}

export interface locationInfo {
    id: string,
    name: string,
    city: string,
    state: string,
    zipcode: string
}
export interface assetInfo {
    id: string,
    name: string,
    type: string,
    status: string,
    assetEquipmentId: string
}
export interface vendorInfo {
    id: string,
    name: string,
    contactNumber: string,
    gsTin: string
}
export interface departmentinfo {
    id: string,
    name: string
}

export interface FileType {
    Callibration: string,
    Tracability: string,
    Invoice: string,
    ServiceReport: string,
    Others: string,
    fileUrl: string;
    fileName: string;
    type: string;
}

export const CertificateRepository = {

    getAllCertificate: async (
        pageNumber: number,
        pageSize: number,
        vendor?: string,
        asset?: string,
        status?: string,
        search?: string,
        appliedSearch?: string
    ): Promise<{ data: Certificate[]; totalCount: number }> => {
        try {
            const response = await axiosInstance.get(`/api/certificates`, {
                params: { pageNumber, pageSize, vendor, asset, status, search, appliedSearch }
            });

            return response.data; // return full object
        } catch (error: any) {
            if (error.response?.status === 404) {
                return { data: [], totalCount: 0 };
            }
            throw error;
        }
    },


    getCertificateById: async (id: string): Promise<Certificate | null> => {
        try {
            const { data } = await axiosInstance.get<Certificate>(
                `/api/certificates/${id}`
            );

            return data;

        } catch (error: any) {
            if (error.response?.status === 404) {

                return null;
            }

            throw error;
        }
    },


    uploadCertificate: async (formData: FormData) => {
        return axiosInstance.post('/api/certificates/upload-multiple', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    updateCertificate: (certificateId: string, formData: FormData) =>
        axiosInstance.patch(
            `/api/certificates/${certificateId}`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        ),



    deleteCertificate: async (id: string): Promise<void> => {
        await axiosInstance.delete(`/api/certificates/${id}`);
    },

    exportCertificate: async (
        format: 'csv' | 'xlsx' = 'csv',
        filters?: {
            search?: string;
            certificateName?: string;
            status?: string;
            vendorName?: string;
            assetName?: string;
            calibrationType?: string;
        }
    ): Promise<Blob> => {

        const params: any = {
            format,
        };
        if (filters?.search) params.search = filters.search;
        if (filters?.status) params.status = filters.status;
        if (filters?.vendorName) params.vendor = filters.vendorName;
        if (filters?.assetName) params.asset = filters.assetName;
        const response = await axiosInstance.get('/api/certificates/export', {
            params,
            responseType: 'blob',
            headers: {
                Accept: 'application/octet-stream',
            },
        });

        return response.data;
    },
    getDownloadDetails: async (): Promise<any[]> => {
        const { data } = await axiosInstance.get("/api/certificates/download-file");
        return data;
    },

    getAllAssets: async (): Promise<Certificate[]> => {
        const { data } = await axiosInstance.get<Certificate[]>('/api/assets');
        return data;
    },
    getallOrg: async (): Promise<Certificate[]> => {
        const { data } = await axiosInstance.get<Certificate[]>('/api/organizations');
        return data;
    },
    getAllCalibrations: async (): Promise<Certificate[]> => {
        const { data } = await axiosInstance.get<Certificate[]>('/api/calibrations');
        return data;
    },
    getCalibrationById: async (id: string): Promise<Certificate> => {
        const { data } = await axiosInstance.get<Certificate>(`/api/calibrations/${id}`);
        return data;
    },

    getHeaderContext: async (orgId: string, locId: string, assetId: string, vendorId: string, departmentId: string): Promise<HeaderContext> => {
        const { data } = await axiosInstance.get<HeaderContext>(
            '/api/calibrations/headercontext',
            {
                params: { orgid: orgId, locid: locId, assetid: assetId, vendorid: vendorId, departmentid: departmentId },
            }
        );
        return data;
    },
    downloadCertificate: async (fileUrl: string): Promise<Blob> => {
        const { data } = await axiosInstance.get<Blob>(
            `/api/certificates/download-file`,
            {
                params: { fileUrl },
                responseType: 'blob',
            }
        );
        return data;
    },

    async getCertificatesByCalibrationId(id: string) {
        try {
            const res = await axiosInstance.get(
                `/api/certificates/by-calibration/${id}`
            );
            return res.data;

        } catch (error: any) {
            if (error.response?.status === 404) {

                return null;
            }

            throw error;
        }
    }



}
